module.exports = __webpack_public_path__ + "static/img/melbourne-beach.689a934.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/melbourne/melbourne-beach.jpg
// module id = 117
// module chunks = 1